module.exports = __webpack_public_path__ + "1a4f9cdbb3936f33f746ab8d23508411.svg";